const palette = {
  primary: {
    700: "#282B8C",
    600: "#373BB2",
    500: "#4548C4"
  },
  secondary: {
    700: "#4254E1",
    600: "#5769F8",
    500: "#7583F7",
    400: "#BCC2FB",
    main: "#7583F7"
  },
  tertiary: {
    600: "#D7D7FF",
    400: "#E8E8F3",
    300: "#EBEBFF",
    200: "#E8E9F7",
    100: "#F3F5FF"
  },
  text: {
    800: "#363554",
    700: "#69687A",
    600: "#A6A6B0",
    primary: "#363554"
  },
  system: {
    800: "#0E0D2A",
    700: "#69687A",
    600: "#A7A6B0",
    500: "#00000050",
    400: "#C7C6CC",
    300: "#E5E5E8",
    200: "#E6E6E9",
    100: "#EEEFF0",
    50: "#F7F7F8",
    0: "#FFFFFF"
  },
  info: {
    700: "#263C5C",
    600: "#41689E",
    500: "#5F98E8",
    400: "#8DBBF2",
    300: "#AFCBF3",
    200: "#EDF5FF",
    100: "#F5FAFF"
  },
  warning: {
    800: "#8A6509",
    700: "#B08310",
    600: "#C39214",
    500: "#F1B00A",
    400: "#F5D688",
    300: "#FDDD8B",
    200: "#FFF2CA"
  },
  error: {
    900: "#5E1B20",
    800: "#902931",
    700: "#A72D49",
    600: "#C13842",
    500: "#EF404B",
    400: "#EF4068",
    300: "#EF9AA1",
    200: "#FBD9DC",
    100: "#FEF0F1"
  },
  success: {
    700: "#397C61",
    600: "#428E6E",
    500: "#4CAF85",
    400: "#A8D8C4",
    300: "#DCEFE8",
    200: "#DDF8EF",
    100: "#F2FCF9"
  },
  charts: {
    blue: {
      500: "#3B82F6"
    },
    magenta: {
      500: "#EC4899"
    }
  },
  grey: {
    900: "#212121",
    800: "#424242",
    700: "#616161",
    600: "#757575",
    500: "#9E9E9E",
    400: "#BDBDBD",
    300: "#E0E0E0",
    200: "#EEEEEE",
    100: "#F5F5F5",
    50: "#FAFAFA"
  }
};

export default palette;
